
<template>
    <div class="xr-pageTip" :style="{paddingTop:marginTop+'px', display:displayStyle}">        
      <img src="/static/failed.png" class="pageTipImage" :style="{width: imgWidth+'px'}" v-if="type == 'failed'" />
      <img src="/static/loading.png" class="pageTipImage" :style="{width: imgWidth+'px'}" v-if="type == 'loading'" />
      <img src="/static/empty.png" class="pageTipImage" :style="{width: imgWidth+'px'}" v-if="type == 'empty'" />
      <img src="/static/service.png" class="pageTipImage" :style="{width: imgWidth+'px'}" v-if="type == 'service'" />
      <p>{{tipText}}</p>
    </div>
</template>
<script>
export default {
    name :'XR-PageTip',
    data(){
      return {
        type : this.mode? this.mode : '',
        tipText: this.text? this.text:'',
        displayStyle:'none',
        imgWidth: document.documentElement.clientWidth * (140/430),
        marginTop: (document.documentElement.clientHeight - 348-56)/2
      }
    },
    props:{
      mode:String,
      text:String
    },
    mounted(){
    },
    methods: {
      ShowFailed(msg){
        this.initTip()
        this.type = 'failed'
        this.tipText = msg
        this.displayStyle = 'block'
      },
      ShowLoading(msg){
        this.initTip()
        this.type = 'loading'
        this.tipText = msg
        this.displayStyle = 'block'
      },
      ShowEmpty(msg){
        this.initTip()
        this.type = 'empty'
        this.tipText = msg
        this.displayStyle = 'block'
      },
      ShowService(msg){
        this.initTip()
        this.type = 'service'
        this.tipText = msg
        this.displayStyle = 'block'
      },
      initTip(){
        this.type = ''
        this.tipText = ''
        this.displayStyle = 'none'
      }
    }
  }
</script>
<style>
.xr-pageTip {
  position: fixed;
    top: 56px;
    bottom: 0;
    text-align: center;
    left: 0;
    right: 0;
    background: #F0F2F5;
    display: none;
}
.xr-pageTip .pageTipImage{

}
</style>


// WEBPACK FOOTER //
// src/components/pageTip/pageTip.vue